/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-05-05 20:59:00
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-07-19 20:28:34
 * @FilePath: /streamline_detail/utils/useBigImages.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { state } from '@/store/index'
import { cookie } from '@zz-common/zz-utils'
import { versionCompare } from './index'

// $ 图文视频预览
export const getCheckBigImageList = (indicatorGroup) => {
  const currentV = cookie.get('v') || '9.13.1'
  const isZero = versionCompare(currentV, '9.12.0') >= 0 ? 0 : 1
  const tabList = []
  indicatorGroup.forEach((group) => {
    const imgList = JSON.parse(JSON.stringify(group.data))
    const imgDataList =
      group.imgDataList && group.imgDataList.length
        ? JSON.parse(JSON.stringify(group.imgDataList))
        : []

    // const reg = /(http|https):\/\/([\w.]+\/?)\S*/
    // const newArrImageList = imgList
    //   .map((i) => setPicSize(i, 1000, 1000))
    //   .map((item) => {
    //     const { pathname } = new URL(reg.test(item) ? item : 'https:' + item)
    //     item = 'https://opic1.zhuanstatic.com' + pathname
    //     return item
    //   })

    // imgDataList.map((item, index) => {
    //   item.url = newArrImageList[index]
    // })
    //质检码
    const qcCode = state.qcCode

    //类目Id
    const cateFirstId = state.cateFirstId

    // infoId
    const infoId = state.infoId

    // 是否显示动态质检反馈入口（入口在查看大图底部）
    const showQuestionnaireUrl = !!(state.showQuestionnaireUrl == 1)
    // 基础参数
    const baseObj = {
      tabName: group.subtitle,
      name: group.title,
      imgList,
      originalLoadable: isZero
    }
    //质检弹窗基础url
    const baseUrl =
      'https://m.zhuanzhuan.com/u/micro_detail/qualitySurvey?wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8&needHideHead=3&hiddenProgress=1&'
    if (group.id == 0) {
      tabList.push({
        ...baseObj,
        // 实拍图对应的反馈入口参数, 每张实拍图对应的jumpurl相同(因为实拍图没有一二三级质检项id)
        actionButton: {
          text: '反馈',
          jumpUrl: `${baseUrl}qcCode=${qcCode}&channelId=3`
        },
        // 查看大图底部反馈入口
        feedBack: showQuestionnaireUrl
          ? {
              text: '实拍图对你有帮助吗？',
              btnText: '我要反馈',
              jumpUrl: `${baseUrl}qcCode=${qcCode}&channelId=3&cateFirstId=${cateFirstId}&infoId=${infoId}`
            }
          : null
      })
    } else {
      const collectObj = group.itemIds
      const actionButtonWithIndex = []
      for (const i in collectObj) {
        const item = collectObj[i]
        // 细节图对应的一二三级质检项
        const [firstItemId = '', secondItemId = '', thirdItemId = ''] = item
        // 细节图对应的反馈入口参数, 每张细节图对应的jumpurl不一致, 因为每张细节图的一二三级质检项id不一样
        actionButtonWithIndex.push({
          imgIndex: Number(i),
          text: '反馈',
          jumpUrl: `${baseUrl}qcCode=${qcCode}&firstItemId=${firstItemId}&secondItemId=${secondItemId}&thirdItemId=${thirdItemId}&channelId=2`
        })
      }
      tabList.push({
        ...baseObj,
        imgDataList, // 存放客户端大图预览的细节图对象 细节图和实拍图都传 方便后续扩展
        actionButtonWithIndex,
        // 查看大图底部反馈入口
        feedBack: showQuestionnaireUrl
          ? {
              text: '细节图对你有帮助吗？',
              btnText: '我要反馈',
              jumpUrl: `${actionButtonWithIndex[0].jumpUrl}&cateFirstId=${cateFirstId}&infoId=${infoId}`
            }
          : null
      })
    }
  })
  return tabList
}
